import settings from '@settings'
import { useUserProfileQry } from 'mmfintech-backend-api'
import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'

export const useExpenseWorkflowCookie = () => {
  const [cookies, setCookie] = useCookies(['expense-modal-shown'])
  const userIds = cookies?.['expense-modal-shown'] || []

  const [shown, setShown] = useState<boolean | null>(null)

  const { profile, profileLoading } = useUserProfileQry()

  useEffect(() => {
    if (!profileLoading) {
      setShown(userIds.includes(profile?.userId))
    }
  }, [profileLoading])

  const onSeen = () => {
    if (!userIds.includes(profile?.userId)) {
      setCookie('expense-modal-shown', JSON.stringify([...userIds, profile?.userId]), {
        path: '/',
        maxAge: 31536000,
        domain: settings.cookieDomain
      })
    }
  }

  return { isShown: shown, onSeen }
}
